"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthSuiteDirectPaymentsService = exports.authSuiteDirectPaymentsService = exports.checkCustomerCouponEligibility = void 0;
var auth_suite_fetch_1 = require("../../auth-suite-fetch");
var directPaymentsProductsPath = "directPayments/products";
var directPaymentsPaymentHistoryPath = "directPayments/history";
var directPaymentsPaymentMethodDetails = "directPayments/customer";
var checkCouponEligibilityPath = "directPayments/customer/checkCouponEligibility";
var directPaymentsCouponDetails = "directPayments/coupons/";
var directPaymentsSubscriptionsPath = "directPayments/subscriptions";
var getAvailableDirectPaymentsProducts = function () {
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.get({
        path: directPaymentsProductsPath,
    });
};
var getDirectPaymentsHistory = function () {
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.get({
        path: directPaymentsPaymentHistoryPath,
    });
};
var getPaymentMethodDetails = function () {
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.get({
        path: directPaymentsPaymentMethodDetails,
    });
};
var getCouponDetails = function (couponCode) {
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.get({
        path: "".concat(directPaymentsCouponDetails, "/").concat(couponCode),
    });
};
var updatePaymentMethodDetails = function (request) {
    var payload = {
        transactionToken: request.transactionToken,
    };
    var body = JSON.stringify(payload);
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.patch({
        body: body,
        path: directPaymentsPaymentMethodDetails,
    });
};
var updateSubscriptionPlan = function (subscriptionId, productId) {
    var request = {
        productId: productId,
    };
    var body = JSON.stringify(request);
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
        body: body,
        path: "".concat(directPaymentsSubscriptionsPath, "/").concat(subscriptionId, "/changePlan"),
    });
};
var checkCustomerCouponEligibility = function (couponCode) {
    var requestBody = { couponCode: couponCode };
    var body = JSON.stringify(requestBody);
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
        body: body,
        path: checkCouponEligibilityPath,
    });
};
exports.checkCustomerCouponEligibility = checkCustomerCouponEligibility;
exports.authSuiteDirectPaymentsService = {
    getAvailableDirectPaymentsProducts: getAvailableDirectPaymentsProducts,
    getDirectPaymentsHistory: getDirectPaymentsHistory,
    getPaymentMethodDetails: getPaymentMethodDetails,
    updatePaymentMethodDetails: updatePaymentMethodDetails,
    updateSubscriptionPlan: updateSubscriptionPlan,
    checkCustomerCouponEligibility: exports.checkCustomerCouponEligibility,
    getCouponDetails: getCouponDetails,
};
var AuthSuiteDirectPaymentsService = /** @class */ (function () {
    function AuthSuiteDirectPaymentsService() {
        return exports.authSuiteDirectPaymentsService;
    }
    return AuthSuiteDirectPaymentsService;
}());
exports.AuthSuiteDirectPaymentsService = AuthSuiteDirectPaymentsService;
